/**
 * Lycabinet Status.
 */

const CREATED = 'created';
const MOUNTED = 'mounted';
const IDLE = 'idle';
const LOADING = 'loading';
const SAVING = 'saving';
const CLEARING = 'clearing';
const DESTROYED = 'destroyed';

export {
  CREATED,
  IDLE,
  LOADING,
  SAVING,
  CLEARING,
  MOUNTED,
  DESTROYED
};
